import { render, staticRenderFns } from "./StarVideo_v2.vue?vue&type=template&id=5a77c21a&"
import script from "./StarVideo_v2.vue?vue&type=script&lang=js&"
export * from "./StarVideo_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports